import { Navigate, useRoutes } from 'react-router-dom';

import { Grid } from '@mui/material';
import * as React from 'react';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import { getDatabase, ref as dbref, child, get } from 'firebase/database';
import { initializeApp } from 'firebase/app';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import Frontend from './layouts/frontend';
import Page404 from './pages/Page404';
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import SolutionPage from './pages/SolutionPage';
import ServicesPage from './pages/ServicesPage';
import ContactUsPage from './pages/ContactUsPage';
import PartnersPage from './pages/PartnersPage';
import EventPage from './pages/portal/EventPage';
import SiteEventPage from './pages/EventPage';
import AnnouncementPage from './pages/AnnouncementPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CodeofConductPage from './pages/CodeofConductPage';
import FrontEventPage from './pages/FrontEventPage';
import FrontAnnouncementPage from './pages/FrontAnnouncementPage';
import FrontSolutionPage from './pages/FrontSolutionPage';
import PartnerPage from './pages/portal/PartnerPage';
import UserPage from './pages/portal/UserPage';
import LoginPage from './pages/LoginPage';
import ForgotPassword from './pages/ForgotPassword';
import NewUserPage from './pages/portal/NewUserPage';
import NewEvent from './pages/portal/NewEvent';
import NewPartner from './pages/portal/NewPartner';
import HomeControl from './pages/portal/HomeControl';
import AboutControl from './pages/portal/AboutControl';
import ServiceControl from './pages/portal/ServiceControl';
import SolutionControl from './pages/portal/SolutionControl';
import ContactUsControl from './pages/portal/ContactUsControl';
import PrivacyControl from './pages/portal/PrivacyControl';
import CodeofConductControl from './pages/portal/CodeofConductControl';
import EventUserControl from './pages/portal/EventUserControl';
import NewAnnouncement from './pages/portal/NewAnnouncement';
import NewSolution from './pages/portal/NewSolution';
import NewServices from './pages/portal/NewServices';
import AnnouncementControl from './pages/portal/AnnouncementPage';
import NewRegisterEventUser from './pages/NewRegisterEventUser';

import { UserAuth } from './context/AuthContext';
// ----------------------------------------------------------------------

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const rtdb = getDatabase(app);

export default function Router() {
  const { user } = UserAuth();
  

  const [loading, setLoading] = useState(true);
  const [frontendpage, setFrontendpage] = useState([
    { element: <Navigate to="/home" />, index: true },
    { path: 'home', element: <HomePage /> },
    { path: 'aboutus', element: <AboutUsPage /> },
    { path: 'solutions', element: <SolutionPage /> },
    { path: 'services', element: <ServicesPage /> },
    { path: 'contactus', element: <ContactUsPage /> },
    { path: 'partners', element: <PartnersPage /> },
    { path: 'event', element: <SiteEventPage /> },
    { path: 'announcement', element: <AnnouncementPage /> },
    { path: 'privacypolicy', element: <PrivacyPolicyPage /> },
    { path: 'code-of-conduct', element: <CodeofConductPage /> },
    { path: 'register_user/:id', element: <NewRegisterEventUser /> },
  ]);



  useEffect(() => {
    const arr = [];
    get(child(dbref(rtdb), `event`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((doc) => {
            arr.push({
              ...doc.val(),
              id: doc.key,
            });
          });

          arr.forEach((val) => {
            frontendpage.push({
              path: `event/${val.prefix}`,
              element: <FrontEventPage data={val} />,
            });
          });
        }

        const arr1 = [];
        get(child(dbref(rtdb), `announcement`))
          .then((snapshot) => {
            if (snapshot.exists()) {
              snapshot.forEach((doc) => {
                arr1.push({
                  ...doc.val(),
                  id: doc.key,
                });
              });

              arr1.forEach((val) => {
                frontendpage.push({
                  path: `announcement/${val.prefix}`,
                  element: <FrontAnnouncementPage data={val} />,
                });
              });
            }

            const arr2 = [];
            get(child(dbref(rtdb), `solutions`))
              .then((snapshot2) => {
                if (snapshot2.exists()) {
                  snapshot2.forEach((doc) => {
                    arr2.push({
                      ...doc.val(),
                      id: doc.key,
                    });
                  });

                  arr2.forEach((val) => {
                    frontendpage.push({
                      path: `solutions/${val.prefix}`,
                      element: <FrontSolutionPage data={val} />,
                    });
                  });

                  setFrontendpage(frontendpage);
                }

                const arr3 = [];
                get(child(dbref(rtdb), `services`))
                  .then((snapshot3) => {
                    if (snapshot3.exists()) {
                      snapshot3.forEach((doc) => {
                        arr3.push({
                          ...doc.val(),
                          id: doc.key,
                        });
                      });

                      arr3.forEach((val) => {
                        frontendpage.push({
                          path: `services/${val.prefix}`,
                          element: <FrontSolutionPage data={val} />,
                        });
                      });

                      setFrontendpage(frontendpage);
                      setLoading(false);
                    } else {
                      setFrontendpage(frontendpage);
                      setLoading(false);
                    }
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              })
              .catch((error) => {
                console.error(error);
              });
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const routes = useRoutes([
    {
      path: '/',
      element: <Frontend />,
      children: frontendpage,
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'resetpassword',
      element: <ForgotPassword />,
    },
    {
      path: '/dashboard',
      element: <Navigate to="/login" replace />,
    },
    {
      path: '/dashboard/*',
      element: <Navigate to="/login" replace />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/home" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  const routesSuperAdmin = useRoutes([
    {
      path: '/',
      element: <Frontend />,
      children: frontendpage,
    },
    {
      path: '/login',
      element: <Navigate to="/dashboard/home" replace />,
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/home" />, index: true },
        { path: 'home', element: <HomeControl /> },
        { path: 'aboutus', element: <AboutControl /> },
        { path: 'contactus', element: <ContactUsControl /> },
        { path: 'services', element: <ServiceControl /> },
        { path: 'privacypolicy', element: <PrivacyControl /> },
        { path: 'codeofconduct', element: <CodeofConductControl /> },
        { path: 'solutions', element: <SolutionControl /> },
        { path: 'user', element: <UserPage /> },
        { path: 'new_user', element: <NewUserPage /> },
        { path: 'event', element: <EventPage /> },
        { path: 'new_event', element: <NewEvent /> },
        { path: 'partners', element: <PartnerPage /> },
        { path: 'new_partner', element: <NewPartner /> },
        { path: 'announcement', element: <AnnouncementControl /> },
        { path: 'new_announcement', element: <NewAnnouncement /> },
        { path: 'new_solution', element: <NewSolution /> },
        { path: 'new_services', element: <NewServices /> },
        { path: 'event/:id', element: <EventUserControl /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/home" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  const routesEditor = useRoutes([
    {
      path: '/',
      element: <Frontend />,
      children: frontendpage,
    },
    {
      path: '/login',
      element: <Navigate to="/dashboard/home" replace />,
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [{ element: <Navigate to="/dashboard/home" />, index: true }],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/home" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  const routesManager = useRoutes([
    {
      path: '/',
      element: <Frontend />,
      children: frontendpage,
    },
    {
      path: '/login',
      element: <Navigate to="/dashboard/home" replace />,
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/user" />, index: true },
        { path: 'user', element: <UserPage /> },
        { path: 'new_user', element: <NewUserPage /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/home" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  const routesAdmin = useRoutes([
    {
      path: '/',
      element: <Frontend />,
      children: frontendpage,
    },
    {
      path: '/login',
      element: <Navigate to="/dashboard/user" replace />,
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/user" />, index: true },
        { path: 'user', element: <UserPage /> },
        { path: 'new_user', element: <NewUserPage /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/home" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  let _userRole = '';

  if (user && user.reloadUserInfo && user.reloadUserInfo.customAttributes) {
    _userRole = JSON.parse(user.reloadUserInfo.customAttributes).role;
  }

  if (user === 'none' || loading) {
    return (
      <Grid
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        backgroundColor: '#000',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.6s ease-in-out',
      }}
    >
      <CircularProgress color="inherit" />
    </Grid>
    );
  }

  if (user && _userRole === 'super_admin') {
    return routesSuperAdmin;
  }

  if (user && _userRole === 'editor') {
    return routesEditor;
  }

  if (user && _userRole === 'manager') {
    return routesManager;
  }

  if (user && _userRole === 'admin') {
    return routesAdmin;
  }

  return routes;
}
